module.exports = __webpack_public_path__ + "static/media/9x16.8152d2a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/9x16.jpg
// module id = 1261
// module chunks = 0